import styled from '@emotion/styled'
import { radius, spacing, font, colors } from '@mobi/component-library/Foundations'

export const Selector = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.md,
  backgroundColor: colors.surface[100],
  border: `0.1rem solid ${colors.neutral[200]}`,
  borderRadius: radius.lgx1,
  padding: `0rem  ${spacing.md} ${spacing.md}`,
})

export const SelectorHeading = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.sm,
  padding: '1.6rem 0',
  ...font.size.md,
  '> div': { flex: 1 },
})

export const MessageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: spacing.smx2,
  fontFamily: font.family.primary,
  '> div:first-of-type': { fontWeight: font.weight.semibold, ...font.size.md },
  '> div:nth-of-type(2)': { color: colors.neutral[800], ...font.size.base },
})

export const ToggleGroupItem = styled.div({
  display: 'grid',
  columnGap: spacing.sm,
  position: 'relative',
  gridTemplateColumns: 'auto 1fr auto auto',
  alignItems: 'center',
  fontFamily: font.family.primary,
  fontWeight: font.weight.medium,
  ...font.size.lg,
  color: colors.neutral['900'],
  borderRadius: radius.lgx1,
  backgroundColor: colors.white,
  border: `1px solid ${colors.neutral['200']}`,
  '&:focus-within': {
    outlineColor: colors.lavender['50'],
  },
  marginRight: '1rem',
  padding: spacing.md,
})

export const ChildrenContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})
